<template>
  <div class="jarviswidget jarviswidget-color-darken">
    <header>
      <h2>
        <slot name="title" />
      </h2>
    </header>
    <div class="smart-form">
      <div
        class="widget-body no-padding"
        :class="{'no-height': noHeight}"
      >
        <fieldset :class="{'no-padding': noPadding}">
          <slot name="content" />
        </fieldset>

        <footer v-if="hasFooter">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  props: {
    noPadding: {
      required: false,
      type: Boolean,
      default: false
    },

    noHeight: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasFooter() {
      return !!this.$slots.footer
    }
  }

}

</script>

<style>
    .jarviswidget .no-height {
        min-height: initial;
    }

    /*.smart-form section {*/
    /*margin-bottom: 0;*/
    /*}*/

    .smart-form section + section {
        margin-bottom: 15px;
    }

    .smart-form fieldset {
        padding: 15px;
    }
</style>
